(function () {
  console.log('[garper-free-gift] JS cargado');

  const CONFIG = window.GARPER_FREE_GIFT || {};

  console.log('[garper-free-gift] CONFIG en JS:', CONFIG);

  if (!CONFIG.enabled) {
    console.warn('[garper-free-gift] No activo: enabled está en false');
    return;
  }

  if (!CONFIG.giftVariantId) {
    console.warn('[garper-free-gift] No activo: falta giftVariantId');
    return;
  }

  let isUpdating = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo leer el carrito');
    }

    return response.json();
  }

  function isGiftItem(item) {
    return Number(item.variant_id) === Number(CONFIG.giftVariantId);
  }

  function getGiftLine(cart) {
    return cart.items.find(isGiftItem);
  }

  function getSubtotalWithoutGift(cart) {
    return cart.items.reduce(function (total, item) {
      if (isGiftItem(item)) {
        return total;
      }

      return total + item.final_line_price;

      /*
        Usamos original_line_price para contar el subtotal antes de descuentos.
          return total + item.original_line_price;
      */
 
    }, 0);
  }

  async function addGift() {
    const properties = {};
    properties[CONFIG.giftPropertyName || '_garper_regalia'] = 'true';

    console.log('[garper-free-gift] Agregando regalo:', CONFIG.giftVariantId);

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(CONFIG.giftVariantId),
        quantity: 1,
        properties: properties
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('[garper-free-gift] Error al agregar:', data);
      throw new Error('No se pudo agregar el bolso regalo');
    }

    return data;
  }

  async function changeGiftQuantity(lineKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error('[garper-free-gift] Error al actualizar:', data);
      throw new Error('No se pudo actualizar el bolso regalo');
    }

    return data;
  }

  async function syncGift() {
    if (isUpdating) return;

    isUpdating = true;

    try {
      const cart = await getCart();
      const giftLine = getGiftLine(cart);
      const subtotalWithoutGift = getSubtotalWithoutGift(cart);
      const qualifies = subtotalWithoutGift >= Number(CONFIG.threshold);

      console.log('[garper-free-gift] subtotal sin regalo:', subtotalWithoutGift);
      console.log('[garper-free-gift] mínimo:', CONFIG.threshold);
      console.log('[garper-free-gift] califica:', qualifies);
      console.log('[garper-free-gift] regalo en carrito:', giftLine);

      if (qualifies && !giftLine) {
        await addGift();
        window.location.reload();
        return;
      }

      if (!qualifies && giftLine) {
        await changeGiftQuantity(giftLine.key, 0);
        window.location.reload();
        return;
      }

      if (qualifies && giftLine && giftLine.quantity !== 1) {
        await changeGiftQuantity(giftLine.key, 1);
        window.location.reload();
        return;
      }
    } catch (error) {
      console.error('[garper-free-gift]', error);
    } finally {
      isUpdating = false;
    }
  }

  window.GARPER_SYNC_FREE_GIFT = syncGift;

  document.addEventListener('DOMContentLoaded', syncGift);

  document.addEventListener('cart:updated', syncGift);
  document.addEventListener('cart:refresh', syncGift);
  document.addEventListener('cart:change', syncGift);

  document.addEventListener('click', function (event) {
    if (
      event.target.closest('button[name="add"]') ||
      event.target.closest('cart-remove-button') ||
      event.target.closest('[data-cart-remove]') ||
      event.target.closest('[href*="/cart/change"]')
    ) {
      setTimeout(syncGift, 1000);
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.closest('quantity-input') ||
      event.target.closest('[data-quantity-input]')
    ) {
      setTimeout(syncGift, 1000);
    }
  });
})();